module.exports = __webpack_public_path__ + "images/starlite/map.png";